import {
  SAVE_SLATE_DATA_FAILURE,
  SAVE_SLATE_DATA_REQUEST,
  SAVE_SLATE_DATA_SUCCESS,
  UPDATE_LAST_SAVED_TIME,
  VENDOR_ROLE_EDITOR_SUBMIT_FAILED,
  VENDOR_ROLE_EDITOR_SUBMIT_REQUEST,
  VENDOR_ROLE_EDITOR_SUBMIT_SUCCESS,
} from '../../../../constants/ActionNameConstants';

const initialState = {
  lastSavedTime: Date.now(),
  data: null,
  loading: false,
  error: null,
};

const saveSlateDataReducer = (state = initialState, action) => {
  switch (action.type) {
    case SAVE_SLATE_DATA_REQUEST:
      return { ...state, loading: true };
    case SAVE_SLATE_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
      };
    case SAVE_SLATE_DATA_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case UPDATE_LAST_SAVED_TIME:
      return {
        ...state,
        lastSavedTime: action.payload,
      };
    default:
      return state;
  }
};




export default saveSlateDataReducer;
